import React, { useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { useAuth } from '../lib/AuthContext'
import { supabase } from '../lib/supabase'

export default function WorkshopOnboardingPage() {
  const { user, profile, loading, refreshWorkshop, signOut } = useAuth()
  const [name, setName] = useState('')
  const [fullName, setFullName] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const navigate = useNavigate()
  if (loading) return <div className="auth-wrap">Loading your account…</div>
  if (!user) return <Navigate to="/login?next=/setup-workshop" replace />
  if (profile) return <Navigate to="/" replace />

  async function createWorkshop(event) {
    event.preventDefault()
    setBusy(true)
    setError('')
    const { error: createError } = await supabase.rpc('create_own_workshop', { workshop_name: name.trim(), full_name: fullName.trim() })
    if (createError) setError(createError.message)
    else {
      await refreshWorkshop()
      navigate('/subscribe', { replace: true })
    }
    setBusy(false)
  }

  return <div className="auth-wrap"><div className="auth-card">
    <div className="auth-logo">Powered by <span>Rebound</span></div>
    <h1>Create your workshop</h1>
    <p>You’re signed in. Complete this step only if you are setting up a new workshop.</p>
    {error && <div className="alert alert-error">{error}</div>}
    <form onSubmit={createWorkshop}>
      <div className="field"><label>Workshop name</label><input value={name} onChange={e => setName(e.target.value)} required maxLength={160} /></div>
      <div className="field"><label>Your name</label><input value={fullName} onChange={e => setFullName(e.target.value)} maxLength={160} /></div>
      <button className="btn btn-primary btn-full" disabled={busy}>{busy ? 'Creating…' : 'Create my workshop'}</button>
    </form>
    <p>Invited to a workshop? Open your invitation email to accept it.</p>
    <button className="btn btn-ghost" onClick={() => navigate('/portal')}>Open rider portal</button>
    <button className="btn btn-ghost" onClick={signOut}>Sign out</button>
  </div></div>
}
